module.exports = __webpack_public_path__ + "media/demo-event-loader/loader@1x-f8e27b40.png";